export default __webpack_public_path__ + "static/media/heartIcon_activeFavourite.531db664.svg";